export enum NOTIFY_TYPES {
  EACH = 'EACH_TEST',
  ALL = 'ALL_TESTS',
  NONE = 'NONE'
}

export enum VALIDATION_CALL_TYPE {
  AT_DIALOG_OPEN = 'AT_DIALOG_OPEN',
  AT_PUBLISH = 'AT_PUBLISH',
  CHECK_ALL = 'CHECK_ALL'
}